<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-comparison-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 660}
    <div id="g-comparison-xs" class="g-artboard" style="">
      <div style="padding: 0 0 134.5455% 0;"></div>
      <div
        id="g-comparison-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/comparison-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:2.1392%;margin-top:-7.5px;left:88.4579%;width:51px;"
      >
        <p class="g-pstyle0">91.48</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:15.6527%;margin-top:-7.5px;left:17.9421%;width:99px;"
      >
        <p class="g-pstyle1">Difficulty total:</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:16.0055%;margin-top:-6.1px;left:40.835%;width:42px;"
      >
        <p class="g-pstyle2">76.6</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:19.7068%;margin-top:-7.5px;left:93.1638%;width:40px;"
      >
        <p class="g-pstyle3">10.1</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:26.914%;margin-top:-7.5px;left:88.1839%;width:29px;"
      >
        <p class="g-pstyle3">8</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:29.1662%;margin-top:-7.5px;left:42.7356%;width:38px;"
      >
        <p class="g-pstyle3">4.3</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:31.1933%;margin-top:-7.5px;left:29.3189%;width:36px;"
      >
        <p class="g-pstyle3">1.8</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:34.7969%;margin-top:-7.5px;left:2.0574%;width:103px;"
      >
        <p class="g-pstyle1">Other elements</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:36.8239%;margin-top:-7.5px;left:83.6411%;width:43px;"
      >
        <p class="g-pstyle3">10.5</p>
      </div>
      <div
        id="g-ai0-10"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:47.1842%;margin-top:-7.5px;left:19.9114%;width:36px;"
      >
        <p class="g-pstyle3">7.2</p>
      </div>
      <div
        id="g-ai0-11"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:51.2383%;margin-top:-7.5px;left:75.2699%;width:40px;"
      >
        <p class="g-pstyle3">11.5</p>
      </div>
      <div
        id="g-ai0-12"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:52.3644%;margin-top:-7.5px;left:32.8032%;width:94px;"
      >
        <p class="g-pstyle0">Lower Scores</p>
      </div>
      <div
        id="g-ai0-13"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:52.5897%;margin-top:-7.5px;left:14.6609%;width:38px;"
      >
        <p class="g-pstyle3">5.9</p>
      </div>
      <div
        id="g-ai0-14"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:60.1572%;margin-top:-29.1px;left:32.5706%;width:111px;"
      >
        <p class="g-pstyle1">Based on current</p>
        <p class="g-pstyle1">scoring, some</p>
        <p class="g-pstyle1">jumps are not</p>
        <p class="g-pstyle1">scored highly</p>
      </div>
      <div
        id="g-ai0-15"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:60.0221%;margin-top:-7.5px;left:12.8584%;width:29px;"
      >
        <p class="g-pstyle3">8</p>
      </div>
      <div
        id="g-ai0-16"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:63.4005%;margin-top:-7.5px;left:66.0146%;width:37px;"
      >
        <p class="g-pstyle3">9.7</p>
      </div>
      <div
        id="g-ai0-17"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:64.7518%;margin-top:-7.5px;left:15.2727%;width:38px;"
      >
        <p class="g-pstyle3">4.9</p>
      </div>
      <div
        id="g-ai0-18"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:73.0851%;margin-top:-7.5px;left:62.2754%;width:30px;"
      >
        <p class="g-pstyle3">11</p>
      </div>
      <div
        id="g-ai0-19"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:73.5356%;margin-top:-7.5px;left:10.7009%;width:37px;"
      >
        <p class="g-pstyle3">9.3</p>
      </div>
      <div
        id="g-ai0-20"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:81.5085%;margin-top:-21.9px;left:17.9455%;width:123px;"
      >
        <p class="g-pstyle1">Both routines</p>
        <p class="g-pstyle1">start with</p>
        <p class="g-pstyle1">high-scoring jumps</p>
      </div>
      <div
        id="g-ai0-21"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:87.7248%;margin-top:-7.5px;left:56.4264%;width:42px;"
      >
        <p class="g-pstyle3">15.2</p>
      </div>
      <div
        id="g-ai0-22"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:87.7248%;margin-top:-7.5px;left:6.0365%;width:42px;"
      >
        <p class="g-pstyle3">15.4</p>
      </div>
      <div
        id="g-ai0-23"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:91.5536%;margin-top:-7.5px;left:1.9064%;width:49px;"
      >
        <p class="g-pstyle4">2006</p>
      </div>
      <div
        id="g-ai0-24"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:91.5536%;margin-top:-7.5px;left:51.6957%;width:48px;"
      >
        <p class="g-pstyle4">2022</p>
      </div>
      <div
        id="g-ai0-25"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:96.1032%;margin-top:-14.7px;left:1.5069%;width:74px;"
      >
        <p class="g-pstyle4">Plushenko</p>
        <p class="g-pstyle4">(RUS)</p>
      </div>
      <div
        id="g-ai0-26"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:96.1032%;margin-top:-14.7px;left:51.8728%;width:48px;"
      >
        <p class="g-pstyle4">Chen</p>
        <p class="g-pstyle4">(US)</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660}
    <div id="g-comparison-md" class="g-artboard" style="">
      <div style="padding: 0 0 118.3333% 0;"></div>
      <div
        id="g-comparison-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/comparison-md.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:3.6062%;margin-top:-10.2px;left:81.5949%;width:61px;"
      >
        <p class="g-pstyle0">91.48</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:16.5383%;margin-top:-10.2px;left:38.6648%;width:57px;"
      >
        <p class="g-pstyle0">76.6</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:16.5383%;margin-top:-10.2px;left:22.4525%;width:125px;"
      >
        <p class="g-pstyle1">Difficulty total:</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:20.625%;margin-top:-9.1px;left:79.2782%;width:43px;"
      >
        <p class="g-pstyle2">10.1</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:27.7953%;margin-top:-9.1px;left:76.3147%;width:30px;"
      >
        <p class="g-pstyle2">8</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:29.7159%;margin-top:-9.1px;left:36.4024%;width:40px;"
      >
        <p class="g-pstyle2">4.3</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:31.7645%;margin-top:-9.1px;left:33.2206%;width:38px;"
      >
        <p class="g-pstyle2">1.8</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:35.1042%;margin-top:-10.2px;left:5.4955%;width:130px;"
      >
        <p class="g-pstyle1">Other elements</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:37.3983%;margin-top:-9.1px;left:71.1328%;width:46px;"
      >
        <p class="g-pstyle2">10.5</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:47.1295%;margin-top:-9.1px;left:25.1737%;width:39px;"
      >
        <p class="g-pstyle2">7.2</p>
      </div>
      <div
        id="g-ai1-11"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:51.3548%;margin-top:-9.1px;left:63.9722%;width:43px;"
      >
        <p class="g-pstyle2">11.5</p>
      </div>
      <div
        id="g-ai1-12"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:52.1337%;margin-top:-10.2px;left:31.7947%;width:118px;"
      >
        <p class="g-pstyle0">Lower Scores</p>
      </div>
      <div
        id="g-ai1-13"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:52.5072%;margin-top:-9.1px;left:21.201%;width:41px;"
      >
        <p class="g-pstyle2">5.9</p>
      </div>
      <div
        id="g-ai1-14"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:57.1529%;margin-top:-29.4px;left:31.6889%;width:167px;"
      >
        <p class="g-pstyle1">Based on current</p>
        <p class="g-pstyle1">scoring, some jumps</p>
        <p class="g-pstyle1">are not scored highly</p>
      </div>
      <div
        id="g-ai1-15"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:59.8055%;margin-top:-9.1px;left:18.104%;width:30px;"
      >
        <p class="g-pstyle2">8</p>
      </div>
      <div
        id="g-ai1-16"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:63.1346%;margin-top:-9.1px;left:56.0556%;width:39px;"
      >
        <p class="g-pstyle2">9.7</p>
      </div>
      <div
        id="g-ai1-17"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:64.1589%;margin-top:-9.1px;left:13.1707%;width:41px;"
      >
        <p class="g-pstyle2">4.9</p>
      </div>
      <div
        id="g-ai1-18"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:72.6096%;margin-top:-9.1px;left:52.857%;width:32px;"
      >
        <p class="g-pstyle2">11</p>
      </div>
      <div
        id="g-ai1-19"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:72.8657%;margin-top:-9.1px;left:9.26%;width:40px;"
      >
        <p class="g-pstyle2">9.3</p>
      </div>
      <div
        id="g-ai1-20"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:81.5319%;margin-top:-19.8px;left:17.7899%;width:190px;"
      >
        <p class="g-pstyle1">Both routines start</p>
        <p class="g-pstyle1">with high-scoring jumps</p>
      </div>
      <div
        id="g-ai1-21"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:86.6941%;margin-top:-9.1px;left:5.2702%;width:46px;"
      >
        <p class="g-pstyle2">15.4</p>
      </div>
      <div
        id="g-ai1-22"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:86.8222%;margin-top:-9.1px;left:47.8539%;width:46px;"
      >
        <p class="g-pstyle2">15.2</p>
      </div>
      <div
        id="g-ai1-23"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:90.1084%;margin-top:-11.7px;left:3.552%;width:63px;"
      >
        <p class="g-pstyle3">2006</p>
      </div>
      <div
        id="g-ai1-24"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:90.2365%;margin-top:-11.7px;left:46.1404%;width:61px;"
      >
        <p class="g-pstyle3">2022</p>
      </div>
      <div
        id="g-ai1-25"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:94.3082%;margin-top:-22.5px;left:46.2919%;width:61px;"
      >
        <p class="g-pstyle3">Chen</p>
        <p class="g-pstyle3">(US)</p>
      </div>
      <div
        id="g-ai1-26"
        class="g-Graphics g-aiAbs g-aiPointText"
        style="top:94.3082%;margin-top:-22.5px;left:3.2101%;width:100px;"
      >
        <p class="g-pstyle3">Plushenko</p>
        <p class="g-pstyle3">(RUS)</p>
      </div>
    </div>
  {/if}
</div>
<!-- End ai2html - 2026-02-20 12:59 -->

<!-- Generated by ai2html v0.100.0 - 2026-02-20 12:59 -->
<!-- ai file: comparison.ai -->
<style lang="scss">
  #g-comparison-box,
  #g-comparison-box .g-artboard {
    margin: 0 auto;
  }
  #g-comparison-box p {
    margin: 0;
  }
  #g-comparison-box .g-aiAbs {
    position: absolute;
  }
  #g-comparison-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-comparison-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-comparison-xs {
    position: relative;
    overflow: hidden;
  }
  #g-comparison-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0.02em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-comparison-xs .g-pstyle0 {
    font-weight: 700;
    height: 14px;
  }
  #g-comparison-xs .g-pstyle1 {
    height: 14px;
  }
  #g-comparison-xs .g-pstyle2 {
    font-weight: 700;
    line-height: 11px;
    height: 11px;
    font-size: 9px;
  }
  #g-comparison-xs .g-pstyle3 {
    height: 14px;
    letter-spacing: 0em;
    color: rgb(25, 45, 74);
  }
  #g-comparison-xs .g-pstyle4 {
    height: 14px;
    letter-spacing: 0em;
    color: rgb(102, 102, 102);
  }
  #g-comparison-md {
    position: relative;
    overflow: hidden;
  }
  #g-comparison-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0.02em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-comparison-md .g-pstyle0 {
    font-weight: 700;
    height: 19px;
  }
  #g-comparison-md .g-pstyle1 {
    height: 19px;
  }
  #g-comparison-md .g-pstyle2 {
    line-height: 17px;
    height: 17px;
    letter-spacing: 0em;
    font-size: 14px;
    color: rgb(25, 45, 74);
  }
  #g-comparison-md .g-pstyle3 {
    line-height: 22px;
    height: 22px;
    letter-spacing: 0em;
    font-size: 18px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
